import {
    Component, OnInit, HostListener, ViewChild, ElementRef
} from '@angular/core';
import { LowerCasePipe } from '@angular/common';
import { ExamPlayerService } from '../_services/ExamPlayerService';
import * as $ from 'jquery';
import * as myGlobals from "../../globals";
import { BrowserModule } from '@angular/platform-browser'

export enum KEY_CODE {
    ALT_D = 68,
    ALT_I = 73, 
    ALT_K = 75,
    ALT_V = 86,
    ALT_W = 87,
	ALT_O = 79,
	ALT_P = 80
	
}
@Component({
    templateUrl: 'app.review.html',
})
export class ReviewComponent implements OnInit {
    public sectionReviewDetails: any;
    public sectionData: any;
    public Preferences: any;
    public inCorrQueCount: boolean = false;
    public TestInfo;
    public isActive;
    public isflagged: boolean = false;
    @ViewChild('dvInstIcon') InstIconReview;
    @ViewChild('instListID') InstListId;
    constructor(public _ReviewQuestions: ExamPlayerService) {
        this.Preferences = $("#hdnObject").val();
    }
    ngOnInit() {
	this.Preferences = JSON.parse(this.Preferences);
	 this.TestInfo = this.Preferences;
	this.LoadThemeCss(this.Preferences.StylesheetName.toLocaleLowerCase());   	
        this.ReviewScreen();
		setTimeout(function () {
		 $('#SectionReview').css("display", "block");
		}, 1000/2);
    }
    ReviewScreen(): any {
        try {			
            this._ReviewQuestions.GetReviewQuestions(myGlobals.appPath, this.Preferences.ScheduleDetailUserID).subscribe(result => {
                var reponseData: any;
                reponseData = result;
                if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                    alert("Review Questions loading failed"); return
                }
                this.sectionData = JSON.parse(reponseData.d);
                this.sectionReviewDetails = this.sectionData.QuestionsData;
                this.sectionReviewDetails = this.IncorrectQuesCount(this.sectionReviewDetails);
            })			
        }
        catch (e) { }
    }
    LoadThemeCss(styleSheet) {
        var CssFileList = [];
        switch (styleSheet) {
            case "html5":
                CssFileList.push("./Themes/HTML5/StyleSheet/styles_en.css");
                break;
            case "gray":
                CssFileList.push("./Themes/gray/StyleSheet/styles_en.css");
                CssFileList.push("./src/app/Test/Style/style_en.css");
                break;
            case "deepblue":
                CssFileList.push("./Themes/deepblue/StyleSheet/styles_en.css");
                CssFileList.push("./src/app/Test/Style/style_en.css");			
                break;
            default:
                CssFileList.push("./Themes/deepblue/StyleSheet/styles_en.css");
                CssFileList.push("./src/app/Test/Style/style_en.css");
                break;
        }
        CssFileList.filter(function (obj) {
            var fileref = document.createElement('link');
            fileref.rel = 'stylesheet';
            fileref.href = obj;
            fileref.media = 'all';
            fileref.type = 'text/css';
            var x = document.getElementsByTagName('head')[0];
            x.appendChild(fileref);

        });		
    }
    dvCollapse(id): any {
        try {
            if ($('#secCont_' + id).is(':visible')) {
                $('#secCont_' + id).css('display', 'none');
                $('#sectTogId_' + id).html('+');
            }
            else {
                $('#secCont_' + id).css('display', 'block');
                $('#sectTogId_' + id).html('-');
            }
        }
        catch (e) { }
    }
    IncorrectQuesCount(SecDetails): any {
        try {
            for (var i = 0; i < SecDetails.length; i++) {
                for (var j = 0; j < SecDetails[i].ReviewSections.length; j++) {
                    if (!SecDetails[i].ReviewSections[j].Iscorrect)
                        SecDetails[i].IncorrectQuesCount = SecDetails[i].IncorrectQuesCount + 1;
                }
            }
            return SecDetails;
        }
        catch (e) { }
    }
    ReviewQuestions(val): any {
        try {
            if (val == 2) {
                for (var i = 0; i < this.sectionReviewDetails.length; i++) {
                    if (this.sectionReviewDetails[i].IncorrectQuesCount > 0) {
                        this.inCorrQueCount = true;
                        break;
                    }
                }
                if (!this.inCorrQueCount) {
                    $("#Reviewhdr").html("No Questions incorrect");
                    $("#ReviewCont").html("No questions have been incorrect for review. Please make your selections and try again.");
                    $('#dvreviewEndPop').show();
                    this.inCorrQueCount = false;
                    return false;
                }
            }
            if (val == 1) {
                for (var i = 0; i < this.sectionReviewDetails.length; i++) {
                    for (var j = 0; j < this.sectionReviewDetails[i].ReviewSections.length; j++) {
                        if (this.sectionReviewDetails[i].ReviewSections[j].IsBookMarked == true && this.isflagged == false) {
                            this.isflagged = true;
                            break;
                        }
                    }
                }
                if (!this.isflagged) {
                    $("#Reviewhdr").html("No Questions flagged");
                    $("#ReviewCont").html("No questions have been flagged for review. Please make your selections and try again.");
                    $('#dvreviewEndPop').show();
                    this.isflagged = false;
                    return true;
                }
            }
            this._ReviewQuestions.SetReviewTestPref(val).subscribe(result => {
                var URL = location.protocol + "//" + window.location.host + '/' + myGlobals.appPath + '/PlayTest.aspx'
                window.location.href = URL;
                return;
            });
        }
        catch (e) { }
    }
    EndReviewQuestions(): any {
        try {

			this._ReviewQuestions.RedirectToNMATReport(myGlobals.appPath,this.TestInfo.AssessmentID,this.TestInfo.ProgramID).subscribe(result => {
						this.OnSuccessTest(result);
					});
           /* this._ReviewQuestions.ReturnTOReport(0).subscribe(result => {
                this.OnSuccessTest(result);
            });*/
            //this.CloseTest();
        }
        catch (e) { }
    }
    OnSuccessTest(objResponse: any) {
        try {
            if (objResponse != null && objResponse.d != null && objResponse.d != '') {
                // var URL = myGlobals.ReportInterfaceURL + "?" + objResponse.d;
                window.location.href = objResponse.d;
                return false;
            }
        }
        catch (ex) { }
    }
    ReviewOnBookmark(QuesGuID, curr, CursecId, QuesIndex): any {
        try {
            if (curr.sectionReviewDetails[CursecId].ReviewSections[QuesIndex].IsBookMarked) {
                curr.sectionReviewDetails[CursecId].ReviewSections[QuesIndex].IsBookMarked = false;
                this.isActive = 0;
                $('#bmk_' + QuesGuID).removeClass();
                $('#bmk_' + QuesGuID).addClass('qst_bookmark');
            }
            else {
                curr.sectionReviewDetails[CursecId].ReviewSections[QuesIndex].IsBookMarked = true;
                this.isActive = 1;
                $('#bmk_' + QuesGuID).removeClass();
                $('#bmk_' + QuesGuID).addClass('qst_bookmarked');
            }
            this._ReviewQuestions.UpdateBookmarkQuesOnReview(this.Preferences.ScheduleDetailUserID, QuesGuID, this.isActive).subscribe(result => {
            })
        }
        catch (e) { }
    }
    CloseTest() {      	  
	  window.opener.location.reload();
       window.close(); return;
    }
    ClosePopUp() {
        try {
            $('#dvreviewEndPop').hide();
        }
        catch (e) { }
    }
    togglediv() {
        try {
            if (this.InstListId.nativeElement.style.display == "none") {
                this.InstIconReview.nativeElement.innerText = '-';
                this.InstListId.nativeElement.style.display = "block";
            }
            else {
                this.InstIconReview.nativeElement.innerText = '+';
                this.InstListId.nativeElement.style.display = "none";
            }
        }
        catch (e) { }
    }
    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
        try {
            if (this.TestInfo.Status == 2 && event.altKey) {
                switch (event.keyCode) {
                    case KEY_CODE.ALT_D: this.EndReviewQuestions();
                        break;
                    case KEY_CODE.ALT_K: if ($('#dvreviewEndPop').is(':visible')) this.ClosePopUp();
                        break;
                    case KEY_CODE.ALT_I: this.ReviewQuestions('2');
                        break;
                    case KEY_CODE.ALT_V: this.ReviewQuestions('1');
                        break;
                    case KEY_CODE.ALT_W: this.ReviewQuestions('0');
                        break;
                }
            }
        }
        catch (e) { }
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Review/app.review.component.ts